/* react-dates constants */
export var MAX_WIDTH = '700px';
export var VERTICAL_ORIENTATION = 'VERTICAL_ORIENTATION';
export var HORIZONTAL_ORIENTATION = 'HORIZONTAL_ORIENTATION';
export var START_DATE = 'START_DATE';
export var END_DATE = 'END_DATE';